import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/modules/common';
import { Routes } from '@/router/routes';

import { useCreateMask } from '../api';
import { MaskForm } from '../components';

export const NewMaskPage: FC = () => {
  const navigate = useNavigate();

  const { createStyleMutation, uploadUrlData, isFetching, refetchUploadUrl } =
    useCreateMask();

  const saveMask = async (data) => {
    if (uploadUrlData?.maskId) {
      try {
        await createStyleMutation.mutateAsync({
          ...data,
          id: uploadUrlData.maskId,
        });
        navigate(Routes.Masks, { replace: true });
        toast.success(`Mask “${data.name}” added successfully!`);
      } catch (error) {
        console.error(error.message);
      }
    }
  };

  const refetchUploadCredentials = async () => {
    try {
      await refetchUploadUrl();
    } catch (error) {
      toast.error('Uh oh! Something went wrong.');
    }
  };

  return (
    <MaskForm
      onSubmit={saveMask}
      uploadUrlData={uploadUrlData}
      refetchUploadCredentials={refetchUploadCredentials}
    >
      {({ isLoading }) => (
        <PageHeader
          title="New Mask"
          asChildPage
          backPath={Routes.Masks}
          actions={[
            <Button
              key="create-mask"
              type="submit"
              data-testid="create-mask-button"
              isLoading={
                isFetching || createStyleMutation.isPending || isLoading
              }
              startIcon={<PlusSquareIcon />}
            >
              Create new mask
            </Button>,
          ]}
        />
      )}
    </MaskForm>
  );
};
